import styled, {css} from 'styled-components';

import {mixins} from '@edna/components/styles';

export const EmptyImage = styled.div`
  ${mixins.stack({align: 'center', justify: 'center'})};
  background-color: #e2e2e2;
  width: 100%;
  min-height: 200px;
  border-radius: ${({theme}) => theme.borderRadius.br2};
`;

export const Button = styled.div`
  width: 100%;
  text-align: center;
  word-break: break-all;
  ${({theme: {palette, spacing, borderRadius}}) => css`
    padding: ${spacing.s2};
    color: ${palette.white};
    background-color: #7c6bde;
    border-radius: ${borderRadius.br12};
  `}
`;

export const Document = styled.img`
  background-color: #e2e2e2;
  ${({theme}) => css`
    max-width: 100%;
    border-radius: ${theme.borderRadius.br2};
  `}
`;
